<button mat-button [matMenuTriggerFor]="animals" mat-raised-button>Select Month</button>
<mat-menu #animals="matMenu">
  
  <button mat-menu-item *ngFor="let month of monthMenuData" (click)=(gotoPage(month.monthId))>{{month.monthName}}</button>
  <!-- <button mat-menu-item *ngFor="let month of monthMenuData" [matMenuTriggerFor]="monthSigns">{{month.monthName}}</button> -->
</mat-menu>


<!-- <mat-menu #monthSigns="matMenu">
  <button mat-menu-item *ngFor="let month of monthMenuData.prevMonth">{{month[0].prevMonth}}</button>
  <button mat-menu-item *ngFor="let month of monthMenuData.nextMonth">{{month}}</button>
</mat-menu>  -->
